export default "__VITE_ASSET__0iZuseL5__"